export const SpecificationData = [
  {
    image: "/assets/images/specification/1.jpg",
    tips: `Bespoke custom-crafted cabinetry in a contemporary
    veneered finish to base and tall units
    · Lacquered wall cabinets with concealed downlighting
    · Soft closing doors and drawers throughout
    · Silestone worktops and matching splashbacks
    · Fully fitted Siemens appliances throughout, including:
    – Integrated induction hob
    – Integrated oven and ecoClean technology
    – Integrated microwave (microwave combi to
    selected units, subject to kitchen design)
    – Fully integrated dishwasher
    – Fully integrated fridge freezer
    – Freestanding washer/dryer (typically located
    in hallway utility cupboard)
    · Re-circulating extractor fan
    · Convenient compartmentalised waste and
    recycling storage
    · Under mounted single or 1 ½ bowl sink
    (subject to kitchen design)
    · Single lever mixer tap with swivel spout,
    finished in chrome`,
    type: "West"
  },
  {
    image: "/assets/images/specification/1.jpg",
    tips: `Bespoke custom-crafted cabinetry in a contemporary
    veneered finish to base and tall units
    · Lacquered wall cabinets with concealed downlighting
    · Soft closing doors and drawers throughout
    · Silestone worktops and matching splashbacks
    · Fully fitted Siemens appliances throughout, including:
    – Integrated induction hob
    – Integrated oven and ecoClean technology
    – Integrated microwave (microwave combi to
    selected units, subject to kitchen design)
    – Fully integrated dishwasher
    – Fully integrated fridge freezer
    – Freestanding washer/dryer (typically located
    in hallway utility cupboard)
    · Re-circulating extractor fan
    · Convenient compartmentalised waste and
    recycling storage
    · Under mounted single or 1 ½ bowl sink
    (subject to kitchen design)
    · Single lever mixer tap with swivel spout,
    finished in chrome`,
    type: "West"
  },
  {
    image: "/assets/images/specification/2-1.jpg",
    image2: "/assets/images/specification/2-2.jpg",
    tips: `Bespoke custom-crafted cabinetry in a contemporary
    veneered finish to base and tall units
    · Lacquered wall cabinets with concealed downlighting
    · Soft closing doors and drawers throughout
    · Silestone worktops and matching splashbacks
    · Fully fitted Siemens appliances throughout, including:
    – Integrated induction hob
    – Integrated oven and ecoClean technology
    – Integrated microwave (microwave combi to
    selected units, subject to kitchen design)
    – Fully integrated dishwasher
    – Fully integrated fridge freezer
    – Freestanding washer/dryer (typically located
    in hallway utility cupboard)
    · Re-circulating extractor fan
    · Convenient compartmentalised waste and
    recycling storage
    · Under mounted single or 1 ½ bowl sink
    (subject to kitchen design)
    · Single lever mixer tap with swivel spout,
    finished in chrome`,
    type: "West"
  },
  {
    image: "/assets/images/specification/2-1.jpg",
    image2: "/assets/images/specification/2-2.jpg",
    tips: `Bespoke custom-crafted cabinetry in a contemporary
    veneered finish to base and tall units
    · Lacquered wall cabinets with concealed downlighting
    · Soft closing doors and drawers throughout
    · Silestone worktops and matching splashbacks
    · Fully fitted Siemens appliances throughout, including:
    – Integrated induction hob
    – Integrated oven and ecoClean technology
    – Integrated microwave (microwave combi to
    selected units, subject to kitchen design)
    – Fully integrated dishwasher
    – Fully integrated fridge freezer
    – Freestanding washer/dryer (typically located
    in hallway utility cupboard)
    · Re-circulating extractor fan
    · Convenient compartmentalised waste and
    recycling storage
    · Under mounted single or 1 ½ bowl sink
    (subject to kitchen design)
    · Single lever mixer tap with swivel spout,
    finished in chrome`,
    type: "West"
  },
  {
    image: "/assets/images/specification/3-1.jpg",
    image2: "/assets/images/specification/3-2.jpg",
    tips: `Bespoke custom-crafted cabinetry in a contemporary
    veneered finish to base and tall units
    · Lacquered wall cabinets with concealed downlighting
    · Soft closing doors and drawers throughout
    · Silestone worktops and matching splashbacks
    · Fully fitted Siemens appliances throughout, including:
    – Integrated induction hob
    – Integrated oven and ecoClean technology
    – Integrated microwave (microwave combi to
    selected units, subject to kitchen design)
    – Fully integrated dishwasher
    – Fully integrated fridge freezer
    – Freestanding washer/dryer (typically located
    in hallway utility cupboard)
    · Re-circulating extractor fan
    · Convenient compartmentalised waste and
    recycling storage
    · Under mounted single or 1 ½ bowl sink
    (subject to kitchen design)
    · Single lever mixer tap with swivel spout,
    finished in chrome`,
    type: "East"
  },
  {
    image: "/assets/images/specification/4.jpg",
    tips: `Bespoke custom-crafted cabinetry in a contemporary
    veneered finish to base and tall units
    · Lacquered wall cabinets with concealed downlighting
    · Soft closing doors and drawers throughout
    · Silestone worktops and matching splashbacks
    · Fully fitted Siemens appliances throughout, including:
    – Integrated induction hob
    – Integrated oven and ecoClean technology
    – Integrated microwave (microwave combi to
    selected units, subject to kitchen design)
    – Fully integrated dishwasher
    – Fully integrated fridge freezer
    – Freestanding washer/dryer (typically located
    in hallway utility cupboard)
    · Re-circulating extractor fan
    · Convenient compartmentalised waste and
    recycling storage
    · Under mounted single or 1 ½ bowl sink
    (subject to kitchen design)
    · Single lever mixer tap with swivel spout,
    finished in chrome`,
    type: "East"
  },
  {
    image: "/assets/images/specification/4.jpg",
    tips: `Bespoke custom-crafted cabinetry in a contemporary
    veneered finish to base and tall units
    · Lacquered wall cabinets with concealed downlighting
    · Soft closing doors and drawers throughout
    · Silestone worktops and matching splashbacks
    · Fully fitted Siemens appliances throughout, including:
    – Integrated induction hob
    – Integrated oven and ecoClean technology
    – Integrated microwave (microwave combi to
    selected units, subject to kitchen design)
    – Fully integrated dishwasher
    – Fully integrated fridge freezer
    – Freestanding washer/dryer (typically located
    in hallway utility cupboard)
    · Re-circulating extractor fan
    · Convenient compartmentalised waste and
    recycling storage
    · Under mounted single or 1 ½ bowl sink
    (subject to kitchen design)
    · Single lever mixer tap with swivel spout,
    finished in chrome`,
    type: "East"
  },
  {
    image: "/assets/images/specification/3-1.jpg",
    image2: "/assets/images/specification/3-2.jpg",
    tips: `Bespoke custom-crafted cabinetry in a contemporary
    veneered finish to base and tall units
    · Lacquered wall cabinets with concealed downlighting
    · Soft closing doors and drawers throughout
    · Silestone worktops and matching splashbacks
    · Fully fitted Siemens appliances throughout, including:
    – Integrated induction hob
    – Integrated oven and ecoClean technology
    – Integrated microwave (microwave combi to
    selected units, subject to kitchen design)
    – Fully integrated dishwasher
    – Fully integrated fridge freezer
    – Freestanding washer/dryer (typically located
    in hallway utility cupboard)
    · Re-circulating extractor fan
    · Convenient compartmentalised waste and
    recycling storage
    · Under mounted single or 1 ½ bowl sink
    (subject to kitchen design)
    · Single lever mixer tap with swivel spout,
    finished in chrome`,
    type: "East"
  }
]
